const scrollToTop = ({ top } = { top: 0 }) => {
  const scrollBlock = document.querySelector('.app__wrapper');

  if (scrollBlock) {
    scrollBlock.scrollTo({
      behavior: 'smooth',
      top,
    })
  }
}

export default scrollToTop;